import { TActionDefinition } from "./reducers"


const actions = {
  SET_ACTIONS: 'HEADER_ACTIONS/SET_ACTIONS',
  SET_STATE: 'HEADER_ACTIONS/SET_STATE',
  GET_STATE: 'HEADER_ACTIONS/GET_STATE',
}

export const setActions = (mainAction: TActionDefinition, subActions: TActionDefinition[]) => {
  return {
    type: actions.SET_ACTIONS,
    payload: {
      mainAction,
      subActions,
    },
  }
}

export default actions
